const ua = navigator.userAgent;

// iOS devices
const isIPhone = /iPhone/i.test(ua);

// iPad / iPadOS:
// - Classic iPad UA contains "iPad"
// - iPadOS 13+ can report as "Macintosh" but has touch points
// IMPORTANT: don't treat normal desktop Macs as iPad.
const isiPadLike = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
const isIPad = /iPad/i.test(ua) || isiPadLike;

// Android
const isAndroid = /Android/i.test(ua);
const isAndroidTablet = isAndroid && !/Mobile/i.test(ua);

// Combined logic
const isTablet = isIPad || isAndroidTablet;
const isMobile = isIPhone || (isAndroid && !isAndroidTablet);
const isDesktop = !isMobile && !isTablet;

const isInStandaloneMode =
    window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

export {
    isTablet,
    isMobile,
    isDesktop,
    isIPhone,
    isIPad,
    isInStandaloneMode,
    isAndroid,
    isAndroidTablet,
};
